import styled from 'styled-components';
import ds from 'designsystem';

import {
  MOBILE_NAV_TRANSITION_SPEED,
  MOBILE_NAV_HEIGHT,
  MOBILE_NAV_TRANSITION_FUNCTION,
} from 'common/consts/navigation';

const MobileNavContainer = styled.nav`
  background-color: ${ds.brand('white')};
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  overflow: auto;
 
  height: ${MOBILE_NAV_HEIGHT};
  
  top: ${({ hidden }) => (hidden ? '-115vh' : '0')};
  transition: top ${MOBILE_NAV_TRANSITION_SPEED} ${MOBILE_NAV_TRANSITION_FUNCTION};
`;

export default MobileNavContainer;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileNavContainer.jsx